import React, {useState} from "react"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import Validation from "@irati/utils/validation"
import GenericModal from "@irati/ui/src/GenericModal"
import {Email, Firstname, Lastname} from "@irati-web/fields/user"
import {Row} from "@irati/ui/src/Layout"
import Spacing from "@irati/ui/src/Spacing"
import Icon from "@irati/ui/src/Icon"
import {Checkbox} from "@irati/ui/src/FormItem"
import mainTheme from "@irati/ui/src/global/theme"
import {useInviteFamilyFriendUser} from "@irati/identity/hooks"
import {User} from "@irati/types"
interface Props {
  onHide: () => void
  onSuccess: (user: User) => void
}
export const InviteFFPopupForm = (props: Props) => {
  const {onHide, onSuccess} = props
  const [confirmAge, setConfirmAge] = useState(false)
  const [inviteUser, {load}] = useInviteFamilyFriendUser()
  const [invitee, setInvitee] = useState({
    firstName: "",
    lastName: "",
    email: ""
  })
  const {formatMessage} = useIntl()
  const sendInvitation = () => {
    inviteUser({
      variables: {
        user: {
          firstName: invitee.firstName,
          lastName: invitee.lastName,
          email: invitee.email
        }
      }
    })
      .then(onSuccess)
      .catch((err) => {
        console.error("Error sending invitation:", err)
      })
  }
  const onChange = (field: string) => (value: string) => {
    setInvitee((prev) => ({
      ...prev,
      [field]: value
    }))
  }
  return (
    <GenericModal
      dismissButtonText="platform.button.cancel"
      proceedButtonText="wallet.familyAndFriends.popup.sendInvitation"
      show
      onConfirm={sendInvitation}
      load={load}
      onHide={onHide}
      title={formatMessage({id: "wallet.familyAndFriends.popup.title"})}>
      <Body maxWidth="100%">
        <FormattedMessage id="wallet.familyAndFriends.popup.subtitle" />
      </Body>
      <Spacing marginTop={2}>
        <Row>
          <Flex>
            <Firstname value={invitee.firstName} onChange={onChange("firstName")} />
            <Lastname value={invitee.lastName} onChange={onChange("lastName")} />
          </Flex>
          <Email value={invitee.email} onChange={onChange("email")} />
        </Row>
      </Spacing>
      <Flex alignItems="flex-start" gap={mainTheme.spacing.one}>
        <Icon icon="info" size={34} />
        <Body color={mainTheme.colors.greys.mediumDark} small>
          <FormattedMessage id="wallet.familyAndFriends.popup.emailAddressInfo" />
        </Body>
      </Flex>
      <Row marginTop={2} marginBottom={2}>
        <Checkbox
          name="check_is_major"
          id="checkMajor"
          checked={confirmAge}
          onChange={() => setConfirmAge(!confirmAge)}
          validation={Validation.bool().oneOf([true], formatMessage({id: "platform.defaultValidation.required"}))}>
          <Body small display="inline">
            <FormattedMessage id="wallet.familyAndFriends.popup.confirmation" />
          </Body>
        </Checkbox>
      </Row>
    </GenericModal>
  )
}
